import { useCallback } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';

import { useHasFeature } from '@views/shared/hooks/hasFeature';

export function useProfile() {
  const route = useRoute<any>();
  const navigation = useNavigation();
  const findMyColleagueEnabled = useHasFeature('find_my_colleague');
  const { id: idFromRoute, colleague: colleagueFromRoute } = route.params || {};

  const goToList = useCallback(() => {
    navigation.navigate('colleagues', {
      screen: 'list',
      initial: false,
    });
  }, [navigation]);

  return {
    id: idFromRoute,
    colleague: colleagueFromRoute,
    goToList,
    findMyColleagueEnabled,
  };
}
